import React, {useState} from "react";
import { Table, Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import commaNumber from "comma-number";

const format = commaNumber.bindWith(",", ".");

const AdvanceCreditorTable = ({ printMode = false, authInfo }) => {
  const { list, loading, filters, totals } = useSelector((state) => state.advanceCreditor);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = [
    { 
      title: "No.", 
      render: (_, __, index) => index + 1, 
      width: 60 
    },
    { 
      title: "Creditor Name", 
      dataIndex: "acc_name",
      ellipsis: true
    },
    { 
      title: "Contact No", 
      dataIndex: "contact_no",
      width: 120
    },
    { 
      title: "Address", 
      dataIndex: "address",
      ellipsis: true
    },
    { 
      title: "Received", 
      dataIndex: "rcv_amount",
      align: "right",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      width: 120
    },
    { 
      title: "Payment", 
      dataIndex: "pay_amount",
      align: "right",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      width: 120
    },
    { 
      title: "Balance", 
      dataIndex: "balance",
      align: "right",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      width: 120
    },
    // !printMode && {
    //   title: "Actions",
    //   className: "no-print",
    //   width: 80,
    //   render: () => (
    //     <Button type="link" icon={<PrinterOutlined style={{ color: "green" }} />} />
    //   ),
    // },
  ].filter(Boolean);
  if (printMode) {
  return (
    <table className="ledger-print-table">
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "10%" }} />
      </colgroup>

      <tbody>
        <tr className="ledger-print-heading">
          <td>No.</td>
          <td>Creditor Name</td>
          <td>Contact No</td>
          <td>Address</td>
          <td style={{ textAlign: "right" }}>Received</td>
          <td style={{ textAlign: "right" }}>Payment</td>
          <td style={{ textAlign: "right" }}>Balance</td>
        </tr>

        {list.map((row, index) => (
          <tr key={`${row.acc_id}-${index}`}>
            <td>{index + 1}</td>

            <td
              style={{
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {row.acc_name}
            </td>

            <td>{row.contact_no}</td>

            <td
            style={{
              maxWidth: "150px",
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
            >
              {row.address}
            </td>

            <td style={{ textAlign: "right" }}>
              {format(parseFloat(row.rcv_amount || 0).toFixed(2))}
            </td>

            <td style={{ textAlign: "right" }}>
              {format(parseFloat(row.pay_amount || 0).toFixed(2))}
            </td>

            <td style={{ textAlign: "right" }}>
              {format(parseFloat(row.balance || 0).toFixed(2))}
            </td>
          </tr>
        ))}

        <tr className="ledger-total-row">
          <td colSpan={4} style={{ textAlign: "right" }}>
            Grand Total
          </td>

          <td style={{ textAlign: "right" }}>
            {format(totals.received.toFixed(2))}
          </td>

          <td style={{ textAlign: "right" }}>
            {format(totals.payment.toFixed(2))}
          </td>

          <td style={{ textAlign: "right" }}>
            {format(totals.balance.toFixed(2))}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey={(record, index) => `${record.acc_id}-${index}`}
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      scroll={printMode ? undefined : { x: 'max-content' }}
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={4}>
            <strong>Grand Total</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={4} align="right">
            <strong>{format(totals.received.toFixed(2))}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5} align="right">
            <strong>{format(totals.payment.toFixed(2))}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6} align="right">
            <strong>{format(totals.balance.toFixed(2))}</strong>
          </Table.Summary.Cell>
          {/* {!printMode && <Table.Summary.Cell index={7}></Table.Summary.Cell>} */}
        </Table.Summary.Row>
      )}
    />
  );
};

export default AdvanceCreditorTable;